var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meeting-ended-container d-flex align-center flex-column mt-7"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t('instructions.completedTitle')))])]),_c('div',{staticClass:"mt-10"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.leave}},[_vm._v(_vm._s(_vm.$t('instructions.joinAnotherMeeting')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }